import { CommentOutlined, DownOutlined } from '@ant-design/icons';
import {
    Dropdown, Flex, theme, Typography,
} from 'antd';
import { Link } from 'react-router-dom';

import { AppRoute } from '@/constants';
import { useUserStore } from '@/stores';

type UserMenuProps = {
    forLightBackground?: boolean;
};

export const UserMenu = ({ forLightBackground = false }: UserMenuProps) => {
    const { user } = useUserStore();
    const { token } = theme.useToken();

    const textColor = forLightBackground ? token.colorText : token.colorTextLightSolid;

    const items = [
        {
            key: 'my-comments',
            label: (
                <Link to={AppRoute.MyComments}>
                    <Flex align="center" gap={8}>
                        <CommentOutlined />
                        Мої коментарі
                    </Flex>
                </Link>
            ),
        },
    ];

    if (!user) {
        return null;
    }

    return (
        <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
            <Flex
                align="center"
                gap={6}
                style={{ cursor: 'pointer', userSelect: 'none' }}
            >
                <Typography.Text
                    style={{
                        lineHeight: 1.4,
                        whiteSpace: forLightBackground ? 'normal' : 'nowrap',
                        wordBreak: forLightBackground ? 'break-word' : undefined,
                        color: textColor,
                    }}
                >
                    {user.email}
                </Typography.Text>
                <DownOutlined style={{ fontSize: 11, color: textColor }} />
            </Flex>
        </Dropdown>
    );
};
